import fetch from 'isomorphic-fetch';
import merge from 'lodash/merge';
import appendQuery from 'append-query';
import ErrorMessage from './ServiceMessages';
import { interpolate, objectFilter } from '../../shared/utils/commonUtils';
import { prepareHeaders, storeTokens } from './handleTokens';
import { storeErrors } from './handleErrors';
import { showLoadder, hideLoadder } from '../slices/loadderSlice';
import { setAmsAPIServerHost } from '../slices/configSlice';

const getDefaultFetchConfig = () => ({
  credentials: 'include',
});

const getFormData = (object) => {
  return Object.keys(object).map(key => `${encodeURIComponent(key) }=${ encodeURIComponent(object[key])}`).join('&');
};

// transTokenSessionItemName is the trans token sessioin item name to save the token
// urlParams = {offerType};
// restConfig contains body, headers...
const fetchBaseQuery = ({ messageConfig = {} }) => async ({
  method, url: path, responseType, urlParams = {}, headers = {}, service,
  isSupportLoader, collectHeaderToken, errorCallback, i18n, ...restConfig
}, api) => {
  const state = api.getState();
  const { propsData = {} } = state;
  const {
    accessToken: propAccessToken, widgetAPIServerHost, widgetNameSpace,
  } = propsData;
  const { accessToken } = state.tokens;
  const { amsAPIServerHost } = state.config;
  const token = accessToken || propAccessToken; // propAccessToken is for cof
  const urlProps = {
    widgetAPIServerHost, amsAPIServerHost, ...urlParams, accessToken: token,
  };
  // accessToken will be supported from widget props or response data
  let url = interpolate(path, urlProps);
  const mergedHeaders = { ...headers, ...prepareHeaders({ headers, widgetNameSpace, collectHeaderToken }) };
  const options = merge(getDefaultFetchConfig(), { ...restConfig, method, headers: { ...mergedHeaders } });

  if (method === 'get') {
    url = appendQuery(url, { ...(options.body || {}), _: new Date().getTime() });
    // FireFox ajax get request can not have a body, so let it be `undefined`
    options.body = undefined;
  } else {
    const isFormUrlencoded = options.headers && options.headers['Content-Type']
    && options.headers['Content-Type'].indexOf('x-www-form-urlencoded') !== -1;
    // Filter null and undfindfind field.
    options.body = isFormUrlencoded
      ? getFormData(objectFilter(options.body || {}))
      : JSON.stringify(objectFilter(options.body || {}));
  }
  isSupportLoader && api.dispatch(showLoadder());
  try {
    const response = await fetch(url, options);
    isSupportLoader && api.dispatch(hideLoadder());
    const { status, ok } = response;
    const resp = await response.text();
    let payload = resp;
    if (responseType === 'json') {
      try {
        payload = JSON.parse(resp || '{}');
      } catch (e) {
        const errorInfo = new ErrorMessage({ code: 'UNKNOWN_ERROR' });
        storeErrors({
          error: errorInfo, api, messageConfig, serviceName: service, errorCallback, i18n,
        });
        return { error: errorInfo.contents };
      }
    }
    if (ok) {
      storeTokens({
        response, payload, api, propsData, widgetNameSpace,
      });
      payload.amsBaseUri && api.dispatch(setAmsAPIServerHost(payload.amsBaseUri));
      return { data: payload };
    }
    const error = new ErrorMessage(payload, status);
    storeErrors({
      error, api, messageConfig, serviceName: service, errorCallback, i18n,
    });
    return { error: error.contents };
  } catch (err) {
    isSupportLoader && api.dispatch(hideLoadder());
    const error = new ErrorMessage(err);
    storeErrors({
      error, api, messageConfig, serviceName: service, errorCallback, i18n,
    });
    return { error: error.contents };
  }
};

export default fetchBaseQuery;
